var _path, _mask, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPocket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 21C5.37258 21 0 15.6274 0 9V3C0 1.34315 1.34315 0 3 0H21C22.6569 0 24 1.34315 24 3V9C24 15.6274 18.6274 21 12 21ZM17.9775 5.952C17.5642 5.95322 17.1701 6.12662 16.89 6.4305L11.967 11.355L7.1325 6.504C6.85643 6.16004 6.44101 5.95756 6 5.952C5.39607 5.95209 4.8511 6.31434 4.61724 6.87115C4.38338 7.42796 4.50625 8.07071 4.929 8.502L4.905 8.5185L9.8445 13.4775L10.905 14.538C11.4907 15.1236 12.4403 15.1236 13.026 14.538L14.0865 13.4775L19.05 8.5185C19.4848 8.08856 19.6151 7.43773 19.3793 6.87354C19.1436 6.30934 18.5889 5.94474 17.9775 5.952Z",
    fill: "#20123A"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 21
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 21C5.37258 21 0 15.6274 0 9V3C0 1.34315 1.34315 0 3 0H21C22.6569 0 24 1.34315 24 3V9C24 15.6274 18.6274 21 12 21ZM17.9775 5.952C17.5642 5.95322 17.1701 6.12662 16.89 6.4305L11.967 11.355L7.1325 6.504C6.85643 6.16004 6.44101 5.95756 6 5.952C5.39607 5.95209 4.8511 6.31434 4.61724 6.87115C4.38338 7.42796 4.50625 8.07071 4.929 8.502L4.905 8.5185L9.8445 13.4775L10.905 14.538C11.4907 15.1236 12.4403 15.1236 13.026 14.538L14.0865 13.4775L19.05 8.5185C19.4848 8.08856 19.6151 7.43773 19.3793 6.87354C19.1436 6.30934 18.5889 5.94474 17.9775 5.952Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPocket);
export default __webpack_public_path__ + "static/media/pocket.90d5ab62.svg";
export { ForwardRef as ReactComponent };